import { render, staticRenderFns } from "./purfaview.vue?vue&type=template&id=d498d3d8&scoped=true&"
import script from "./purfaview.vue?vue&type=script&lang=js&"
export * from "./purfaview.vue?vue&type=script&lang=js&"
import style0 from "./purfaview.vue?vue&type=style&index=0&id=d498d3d8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d498d3d8",
  null
  
)

export default component.exports